<template>
  <div>

    <div id="fb-root"></div>

    <div @click="showFb" id="facebook-clicker"></div>

    <div style="display: none;" id="hidden-fb">
      <div class="fb-page" :data-href="dataHref" data-tabs="timeline" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote :cite="dataHref" class="fb-xfbml-parse-ignore"><a :href="dataHref">{{linkText}}</a></blockquote></div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['data-href', 'link-text'],
  name: 'VueFacebookPage'
}
</script>

<style scoped>
  .fb-page {
    z-index: 1000;
    position: fixed!important;
    top: calc(50% - 130px);
    left: 0;
  }

#facebook-clicker {
  cursor: pointer;
  z-index: 1000;
  width: 170px;
  height: 60px;
  position: fixed;
  top: calc(50% - 75px);
  left: -59px;
  background-image: url('./assets/facebook.png');
  background-size: cover;
  background-repeat: no-repeat;
  transform: rotate(-90deg);
  border-radius: 0px 0px 15px 15px;
}

@media screen and (max-width: 615px) {
  #facebook-clicker {
    display: none;
  }
}
</style>
